// swiper
const bannerBackground01 = require('common/pc/images/banner_background_01.png')
const bannerBackground03 = require('common/pc/images/banner_background_03.png')
const sj = require('common/pc/images/sj.jpg')
const bibleExhibition = require('common/pc/images/bible_exhibition.png')
const qr365 = require('common/pc/images/qr-365.png')
const grace365 = require('common/pc/images/grace_365.png')
// 产品动态
const mainProduct = require('common/pc/images/main_product.png')
const secondProduct = require('common/pc/images/second_product.png')

const data = {
  mainProduce: [
    {
      bakImg: bannerBackground01,
      title: '主内圣经',
      intro: '——我们让在线读经变得更加丰富多彩',
      qrImg: sj,
      contentImg: bibleExhibition,
      typeCt: [
        {
          name: 'Android端',
          link: null,
          img: sj
        },
        {
          name: 'IOS端',
          link: null,
          img: sj
        },
        {
          name: '在线阅读',
          link: 'http://holy-bible.net/readBible.html',
          img: null
        }
      ]
    },
    {
      bakImg: bannerBackground03,
      title: '恩典365',
      intro: '365天，一起活着神的爱和恩典里面',
      qrImg: qr365,
      contentImg: grace365,
      typeCt: [
        {
          name: 'Android端',
          link: null,
          img: qr365
        },
        {
          name: 'IOS端',
          link: null,
          img: qr365
        }
      ]
    }
  ],
  produceActive: [
    {
      title: '主内圣经',
      img: mainProduct,
      more: 'https://bible.com.cn/index.html',
      content: [
        {
          item: '新版本 v1.0.8 多本注释以及译本...',
          date: '2019-05-02'
        },
        {
          item: '新版本 v1.0.7 使用教程：如何切换圣经译...',
          date: '2019-05-01'
        },
        {
          item: '新版本 v1.0.6 多种新功能...',
          date: '2019-04-27'
        },
        {
          item: '主内圣经 版本 v 1.0.0 上线了',
          date: '2019-04-17'
        }
      ]
    },
    {
      title: '福音广告',
      img: secondProduct,
      more: null,
      content: [
        {
          item: '福音广告二期跟进端公测',
          date: '2019-05-13'
        },
        {
          item: '福音广告一期发布上线了',
          date: '2019-04-25'
        },
        {
          item: '线下活动完美收官',
          date: '2019-04-17'
        },
        {
          item: '福音广告一期公测开始了~~',
          date: '2019-04-01'
        }
      ]
    }
  ]
}
export default data



// WEBPACK FOOTER //
// ./src/common/pc/js/produce.js